import { OwnerLettersTab, canReadLetters } from '@/Containers/CommunicationSection/LetterContainer/Hooks'
import { EntityPanel } from '@/Ship/Components/EntityCard'

import type { ReactNode } from 'react'

/** Ключ вкладки «Листи» в картках перевезень — на нього картка перечитує список. */
export const TRANSPORT_LETTERS_TAB_KEY = 'letters'

/**
 * Вкладка «Листи» картки заявки, запиту чи тендера (`SPEC-025` §3.2; легасі
 * `CompanyEmailCrud` з `prefilter` джерела, `ApplicationFormTemplate.jsx:176-185`,
 * `RequestFormTemplate.jsx:110-118`): листи джерела й кнопка «Відправити
 * лист» з шаблонами його провайдера. Вміст — публічне API контейнера листів.
 *
 * Без права на листи вкладки немає зовсім, як у картках клієнта й
 * перевізника. Хто бачить листи джерела, вирішує бек: право читати саме
 * заявку, запит чи тендер (`LetterRule`).
 *
 * @param epoch лічильник відкриттів вкладки — перемонтовує список, щоб він
 *        перечитався після змін в інших вкладках
 */
export const transportLettersTab = (
    owner: 'application' | 'request' | 'tender',
    uuid: string,
    epoch: number
): { key: string; label: string; children: ReactNode }[] =>
    canReadLetters()
        ? [
              {
                  key: TRANSPORT_LETTERS_TAB_KEY,
                  label: 'Листи',
                  children: (
                      <EntityPanel>
                          <OwnerLettersTab key={epoch} owner={owner} record={{ uuid }} />
                      </EntityPanel>
                  ),
              },
          ]
        : []
